import { DonationMatching } from '@/app/api';
import { CoinsIcon } from '@/app/components/CoinsIcon/CoinsIcon';
import Tooltip from '@/app/components/Tooltip/Tooltip';
import { formatPriceInCents } from '@/app/utils/formatting';
import { Trans, useTranslation } from 'react-i18next';

type MatchingBoxProps = {
  matching: DonationMatching;
};

export const MatchingBox = ({ matching }: MatchingBoxProps) => {
  const { t } = useTranslation();

  if (matching.currentAmountInCents >= matching.maxAmountInCents) {
    return (
      <div className="flex items-center gap-[8px] mt-[16px] text-[14px] w-full justify-center">
        <div className="w-full text-center text-neutral-semiTransparent">
          {t('components.DonateBox.donationsMatchingFinished', {
            amountWithCurrency: formatPriceInCents(matching.maxAmountInCents),
          })}
        </div>
        {matching.logo ? (
          <img alt="company logo" src={matching.logo} height={90} width={90} />
        ) : (
          <div>{matching?.name}</div>
        )}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-[8px] mt-[16px] text-[14px] w-full justify-center">
      <CoinsIcon className="text-black h-[24px] w-[24px]" />
      <span className="">
        <Trans i18nKey="components.DonateBox.donationMatching">
          <abbr
            className="decoration-dotted underline"
            data-tooltip-id={'dropdown'}
            data-tooltip-html={t('components.DonateBox.donationMatchingTooltip', {
              amountWithCurrency: formatPriceInCents(matching.maxAmountInCents * 2),
            })}
          >
            Zdvojnásobíme
          </abbr>
          váš dar
        </Trans>
      </span>
      <Tooltip isDark id="dropdown" place="bottom" className="!w-[300px] shadow-sm ">
        test
      </Tooltip>
      {matching.logo ? (
        <img alt="company logo" src={matching.logo} height={90} width={90} />
      ) : (
        <div>{matching?.name}</div>
      )}
    </div>
  );
};
